import { useAuthContext } from "../../core/contexts/AuthContextProvider";

const usePermission = (module, feature) => {
  const { isAuthorizedToAccess } = useAuthContext();

  return isAuthorizedToAccess?.(module, feature) || false;
};

export default usePermission;
